import { render, staticRenderFns } from "./MarketingFormSend.vue?vue&type=template&id=5b39f0d2&scoped=true"
import script from "./MarketingFormSend.vue?vue&type=script&lang=js"
export * from "./MarketingFormSend.vue?vue&type=script&lang=js"
import style0 from "./MarketingFormSend.vue?vue&type=style&index=0&id=5b39f0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39f0d2",
  null
  
)

export default component.exports